import React, { FunctionComponent } from 'react';
import styles from './Workers.module.scss';
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper';
import { Block, BlockContent } from 'components/elements';
import { SingleWorker } from 'components/presentional';
import { Swiper, SwiperSlide } from 'swiper/react';
import { WPAcfWorkers } from 'types/acf/workes';
import snakeCase from 'lodash-es/snakeCase';
import messages from 'messages/base-pl';
import { useIntl } from 'react-intl';

SwiperCore.use([Navigation, Pagination, A11y]);

interface OwnProps {
  data: WPAcfWorkers | null;
}

type WorkersProps = JSX.IntrinsicElements['div'] & OwnProps;

const Workers: FunctionComponent<WorkersProps> = props => {
  const { data } = props;
  const { formatMessage } = useIntl();

  if (!data || !data.items) {
    return null;
  }

  const { items } = data;
  const useSwiper = items && items.length > 1;

  const a11y = {
    prevSlideMessage: formatMessage(messages.prev_slide),
    nextSlideMessage: formatMessage(messages.next_slide),
    paginationBulletMessage: formatMessage(messages.slide_message),
  };

  return (
    <Block id="workers" theme="light" data-module="workers">
      <BlockContent>
        <div className={styles.wrapper}>
          {useSwiper && (
            <Swiper a11y={a11y} loop={true} navigation pagination={{ clickable: true }}>
              {items
                ?.filter(worker => worker?.description && worker?.name)
                .map((worker, index) => (
                  <SwiperSlide key={`${snakeCase(worker.name)}-${index}`}>
                    <SingleWorker hero={false} worker={worker} />
                  </SwiperSlide>
                ))}
            </Swiper>
          )}
        </div>
        {!useSwiper && items?.map((worker, index) => <SingleWorker hero={false} key={`${snakeCase(worker.name)}-${index}`} worker={worker} />)}
      </BlockContent>
    </Block>
  );
};

export default Workers;
